import { useEffect, useRef, useState } from "react";
import "./FacilityDetail.css";

import { collection, getDocs, query, orderBy, where } from "firebase/firestore";

import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation, Pagination } from "swiper";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

SwiperCore.use([Navigation, Pagination]);

function FacilityDetail(props) {
  const [FacilityDb, SetFacilityDb] = useState([]);
  const [FacilityLoading, SetFacilityLoading] = useState(false);

  

  useEffect(() => {
    if(!FacilityLoading){
      LoadingFacilityData(props.FcSpotType);
    } 
  }, []);

  async function LoadingFacilityData(FcSpotType) {
    SetFacilityLoading(false);

    const UserListRef = collection(props.db, "Facility");
    const querySnapshot = await getDocs(query( UserListRef, where("Spot", "==", FcSpotType), orderBy("No", "asc")));

    const Facility = [];
    querySnapshot.forEach((doc) => { Facility.push(doc.data()); });

    SetFacilityDb(Facility);
    SetFacilityLoading(true);
  }

  const MetalFNaviPrev = useRef(null);
  const MetalFNaviNext = useRef(null);
  const MetalFPagination = useRef(null);

  return (
    <div className="FacilityDetail flex w-full flex-col">
      <div className="flex h-6"></div>
      <div className="List-Top flex w-full">
        <div className="SwiperLists flex w-10 justify-center items-center">No</div>
        <div className="SwiperLists flex flex-1 justify-center items-center">설비명</div>
        <div className="SwiperLists flex w-20 justify-center items-center">설비종류</div>
        <div className="SwiperLists flex flex-1 justify-center items-center">설비표준</div>
        <div className="SwiperLists flex w-20 justify-center items-center"> 보유대수</div>
      </div>

      {FacilityLoading && (
        <>
          <Swiper
            slidesPerView={1}
            navigation
            pagination={{
              el: MetalFPagination.current,
              clickable: true,
            }}
            onSwiper={(swiper) => {
              setTimeout(() => {
                if (
                  MetalFNaviPrev.current &&
                  MetalFNaviNext.current
                ) {
                  swiper.params.navigation.prevEl = MetalFNaviPrev.current;
                  swiper.params.navigation.nextEl = MetalFNaviNext.current;

                  swiper.navigation.destroy();
                  swiper.navigation.init();
                  swiper.navigation.update();

                  swiper.params.pagination.el = MetalFPagination.current;
                  swiper.pagination.destroy();
                  swiper.pagination.init();
                  swiper.pagination.render();
                  swiper.pagination.update();
                }
              });
            }}
            className="flex w-full List-Bottom"
          >
            {Array.from({
              length: Math.ceil(FacilityDb.length / 5),
            }).map((_, pageIndex) => (
              <SwiperSlide key={pageIndex}>
                {FacilityDb.slice(pageIndex * 5, pageIndex * 5 + 5).map(
                  (facility, index) => (
                    <div className="Lists flex w-full" key={facility.id}>
                      <div className="flex w-10 justify-center items-center">{pageIndex * 5 + index + 1}</div>
                      <div className="flex flex-1 justify-center items-center">{facility.Name}</div>
                      <div className="flex w-20 justify-center items-center">{facility.Type}</div>
                      <div className="flex flex-1 justify-center items-center">{facility.Standard}</div>
                      <div className="flex w-20 justify-center items-center">{facility.Quantity}</div>
                    </div>
                  )
                )}
              </SwiperSlide>
            ))}
          </Swiper>

          <div className="PagingTool flex w-full h-10">
            <div className="flex flex-1"></div>

            <div className="swiper-buttonPrev flex justify-end items-center">
              <i className="fa-solid fa-chevron-left" ref={MetalFNaviPrev} ></i>
            </div>

            <div className="flex flex-1 justify-center items-center" ref={MetalFPagination} ></div>

            <div className="swiper-buttonNext flex justify-start items-center">
              <i className="fa-solid fa-chevron-right" ref={MetalFNaviNext} ></i>
            </div>

            <div className="flex flex-1 h-10"></div>
          </div>
        </>
      )}
    </div>
  );
}

export default FacilityDetail;